import script from "./WatchIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./WatchIndex.vue?vue&type=script&setup=true&lang=js"

import "./WatchIndex.vue?vue&type=style&index=0&id=300850a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-300850a6"]])

export default __exports__